<template>
  <div class="teachingActivity">
    <div class="activity_box">
      <div class="header">
        <div class="button_box">
          <span class="button" :class="activeButton==1?'active_button':''" @click="FilterStutas(1)">进行中</span>
          <span class="button" :class="activeButton==0?'active_button':''" @click="FilterStutas(0)">已结束</span>
        </div>
      </div>
      <div class="activity_list">
        <div class="list_box" v-if="selectActivityList.length!=0">
          <div class="activity_item" v-for="item in selectActivityList.slice((pageParams.page-1)*pageParams.size,pageParams.page*pageParams.size)" :key="item.id" @click="getDetial(item)">
            <div class="icon_box">
              <i class="iconfont" :style="{color:operateList[item.type-1].color,fontSize:'22px'}" v-html="operateList[item.type-1].icon"></i>
            </div>
            <div class="activity_info">
              <div class="activity_name"><span class="activity_type">[{{ operateList[item.type-1].name }}]</span><span class="activity_type">{{ item.name }}</span><span
                  :style="{color:item.status==1?'#21B94B':'#4E5569',background:item.status==1?'rgba(33,185,75,0.1)':'#E5E7EB',padding:'2px 3px', borderRadius: '4px',fontSize:'12px'}">{{ item.status==1?"进行中":'已结束' }}</span></div>
              <div class="create_time">
                <div class="left">
                  <div>创建时间:{{ item.create_time }}</div>
                  <div style="margin-left: 20px;" v-if="item.type==1 || item.type==2">{{  item.total_participants}}人提交</div>
                </div>
              </div>
            </div>

          </div>
          <div class="pagination">
            <el-pagination :background="true" @current-change="handleCurrentChange" :current-page="pageParams.page" :page-size="pageParams.size" layout=" prev, pager, next" :total="selectActivityList.length">
            </el-pagination>
          </div>
        </div>
        <div class="list_box" v-else style="color: #666;display: flex;align-items: center;justify-content: center; height: 300px;">
          暂无活动
        </div>

      </div>
    </div>
  </div>
</template>
  
  <script>
import WsConfig from "@/utils/wsConfig";
import { sendWsData } from "@/utils/utils";
export default {
  name: "teacherTextbook",
  components: {},
  data() {
    return {
      operateList: [
        {
          name: "签到",
          id: 1,
          title: "发起签到",
          icon: "&#xe768;",
          color: "#2654FF",
        },
        {
          name: "投票",
          id: 2,
          title: "发起投票",
          icon: "&#xe767;",
          color: "#EE7218",
        },
        {
          name: "选人",
          id: 3,
          title: "发起选人",
          icon: "&#xe766;",
          color: "#2654FF",
        },
        {
          name: "抢答",
          id: 4,
          title: "发起抢答",
          icon: "&#xe763;",
          color: "#EE7218",
        },
        {
          name: "主题讨论",
          id: 5,
          title: "发起主题讨论",
          icon: "&#xe765;",
          color: "#2654FF",
        },
        {
          name: "随堂练习",
          id: 6,
          title: "随堂练习",
          icon: "&#xe764;",
          color: "#0092FF",
        },
      ],
      durationList: [
        {
          label: "1分钟",
          value: 1,
        },
        {
          label: "2分钟",
          value: 2,
        },
        {
          label: "3分钟",
          value: 3,
        },
        {
          label: "5分钟",
          value: 4,
        },
        {
          label: "不限时",
          value: 5,
        },
      ],
      wsIns: null,
      wsTimer: null,
      paperList: [],
      pageParams: {
        page: 1,
        size: 10,
        total: 0,
      },
      selectActivityList: [],
      activityList: [],
      activeButton: 1,
    };
  },
  created() {
    this.websocketInit();
    this.getActivityList();
  },

  methods: {
    websocketInit() {
      this.wsIns = new WebSocket(WsConfig.url);
      console.log("WsConfig.url", WsConfig.url);

      this.wsIns.onopen = () => {
        this.wsIns.send(sendWsData("bind"));
        if (this.wsTimer) clearInterval(this.wsTimer);
        this.wsTimer = setInterval(() => {
          const sendMsg = sendWsData("ping");
          this.wsIns.send(sendMsg);
        }, 50000);
      };
      this.wsIns.onmessage = (evt) => {
        const data = JSON.parse(evt.data);

        switch (data.type) {
          // 连接成功
          case "connect":
            this.bindClient(data.data.client_id);
            break;
          case "new_act":
            console.log("收到新活动通知：", data);
            this.getActivityList();
            this.activeButton=1
            // this.$message.info(`教师发布 ${data.data.name}活动,请前往教学活动查看`)
            break;
          case "stop_act":
            console.log("活动停止：", data);
            this.getActivityList();
            this.activeButton=1
            // 可以在这里做一些活动停止后的处理，如隐藏抢答按钮等
            break;
          case "del_act":
            console.log("活动删除：", data);
            // 可以在这里做一些活动删除后的处理，如移除相关提示等
            // this.$message.warning(`${data.data.name}已被删除`)
            this.getActivityList();
            this.activeButton=1
            break;
          case "join_group":
            console.log("加入班级", data);

            break;
          case "reset_select_person":
            console.log("重置选人", data);

            // this.$message.info(`教师重置选人,请刷新`)
            // window.location.reload();
            // this.websocketInit()

            break;
          case "rand_select_person":
            console.log("随机选人", data);

            break;
          default:
          // console.log("收到未知类型消息：", data);
        }
      };
      //断开之后重连
      this.wsIns.onclose = () => {
        console.log("已断开连接，尝试重新连接");
        this.websocketInit();
      };
    },
    // 绑定客户端
    bindClient(client_id) {
      this.$shttp.axiosPost(
        this.$api.jdWsBind,
        { client_id: client_id },
        (res) => {
          if (res.code == 200) {
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getActivityList() {
      let params = {
        class_id: localStorage.getItem("c_id"),
        page: 1,
        page_size: this.pageParams.size,
        course_id: this.$route.query.course_id,
        course_chapter: this.$route.query.zhangIndex,
        course_node: this.$route.query.jieIndex,
      };
      this.$http.axiosPost(
        this.$api.jdActivities,
        params,
        (res) => {
          if (res.code === 200) {
            this.pageParams.total = res.data.total;
            this.activityList = res.data.data;
            this.selectActivityList = this.activityList.filter(
              (item) => item.status == 1
            );
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getDetial(item) {
      localStorage.setItem(
        "query",
        JSON.stringify({
          id: item.id,
          name: item.name,
          type: item.type,
          create_time: item.create_time,
          duration: item.duration,
          status: item.status,
          jieName: this.$route.query.jieName,
          zhangName: this.$route.query.zhangName,
        })
      );
      this.$router.push({
        path: "/qualityCourse/ActivityDetial",
      });
    },
    FilterStutas(type) {
      this.activeButton = type;
      this.selectActivityList = this.activityList.filter(
        (item) => item.status == type
      );
    },
    handleCurrentChange(val) {
      this.pageParams.page = val;
      console.log(this.selectActivityList, "this.selectActivityList");
    },
  },
};
</script>
  
  <style scoped lang="scss">
.teachingActivity {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .activity_box {
    width: 100%;
    height: calc(100vh - 154px);
    overflow-y: auto;
    background: #fff;
    .header {
      display: flex;
      justify-content: flex-start;
      height: 70px;
      align-items: center;
      padding: 0 30px;
      box-sizing: border-box;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      .button_box {
        border-radius: 4px;
        display: flex;
        border: 1px solid #dcdfe6;
        .button {
          width: 88px;
          height: 36px;
          background: #fff;
          color: #333;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:nth-of-type(1) {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            border-right: 1px solid #dcdfe6;
          }
          &:nth-of-type(2) {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
        }
        .active_button {
          background: #006eff;
          color: #fff;
        }
      }
    }
  }
}

.dialog_box {
  max-height: 500px;
  overflow-y: auto;
  padding-right: 20px;
  box-sizing: border-box;
}
.el-radio {
  margin-bottom: 0;
}
.addSelect {
  width: 88px;
  height: 36px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #006eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #006eff;
}
::v-deep .el-radio__label {
  min-width: 10px;
  display: inline-block;
  background: none !important;
  color: #333;
  border-radius: 0;
  border: none;
  padding: 0px;
  padding-left: 8px;
  margin-left: 0px;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  border: none !important;
  color: #333 !important;
}
::v-deep .el-radio-group {
  height: 98%;

  padding: 0;
  padding-left: 0;
  box-sizing: border-box;
}
/* 设置滚动条整体 */
::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
  height: 6px; /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #a2a2a2; /* 滑块背景色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #767575; /* 滑块悬停背景色 */
}
::v-deep .el-input__inner {
  background: #fff !important;
}
::v-deep .el-textarea__inner {
  min-height: 100px !important;
}
.activity_list {
  width: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
  .list_box {
    width: 100%;
    .activity_item {
      border-bottom: 1px solid #dddddd;
      padding: 20px 30px;
      box-sizing: border-box;
      display: flex;
      cursor: pointer;
      &:nth-of-type(1) {
        border-top: 1px solid #dddddd;
      }
      .icon_box {
        display: flex;
        width: 40px;
        height: 40px;
        background: #f5f5f5;
        border-radius: 4px 4px 4px 4px;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
      }
      .activity_info {
        width: 100%;
        .activity_name {
          .activity_type {
            font-family: PingFang SC, PingFang SC;
            font-size: 14px;
            color: #333333;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            font-weight: 600;
            margin-right: 10px;
          }
        }
        .create_time {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 6px;
          .left {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #999999;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: flex;
            align-items: center;
          }
          .right {
            display: flex;
            align-items: center;
            .end_activity {
              color: #4f7bfd;
              margin-right: 10px;
              cursor: pointer;
            }
            .delete_button {
              color: #fd4f4f;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: end;
  .el-button {
    width: 88px;
    height: 36px;
    background: #f2f4f7;
    border-radius: 4px 4px 4px 4px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #3e3e3e;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.pagination {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>